import React from 'react';
import { Chip, Zoom, makeStyles } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        top: '75px', // Logo abaixo da NavBar
        right: '25px',
        zIndex: 1101, // Acima da NavBar que é 1100
        cursor: 'pointer',
        backgroundColor: '#f0f7ff', // Azul muito claro
        color: '#17497F',
        fontWeight: 'bold',
        border: '1px solid #17497F33',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        '&:hover': {
            backgroundColor: '#e0efff',
        },
        '& .MuiChip-icon': {
            color: '#17497F',
        },
    },
    pulse: {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#52d869', // Verde oficial do Duzz
        marginLeft: '8px',
        animation: '$pulse-animation 2s infinite',
    },
    '@keyframes pulse-animation': {
        '0%': {
            boxShadow: '0 0 0 0px rgba(82, 216, 105, 0.7)',
        },
        '70%': {
            boxShadow: '0 0 0 10px rgba(82, 216, 105, 0)',
        },
        '100%': {
            boxShadow: '0 0 0 0px rgba(82, 216, 105, 0)',
        },
    },
}));

const TutorialTrigger = ({ show, onStart }) => {
    const classes = useStyles();

    return (
        <Zoom in={show}>
            <Chip
                icon={<HelpOutlineIcon />}
                label={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        Tutorial disponível
                        <span className={classes.pulse}></span>
                    </span>
                }
                onClick={onStart}
                className={classes.root}
            />
        </Zoom>
    );
};

export default TutorialTrigger;
